import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import router from '@router/index'

// Styles
import '@assets/main.css' // Import Tailwind CSS

// OpenLIME
import '@libs/openlime/openlime.js'

// i18n
import { i18n } from '@/i18n'

// Stores
import { useAuthStore } from '@/stores/auth'
import { useCacheStore } from '@/stores/cache'
import { useI18nStore } from '@/stores/i18n'
import { useUserPreferencesStore } from '@/stores/userPreferences'

// Fonction d'initialisation asynchrone
async function initializeApp() {
  const app = createApp(App)

  // Initialiser Pinia
  const pinia = createPinia()
  app.use(pinia)

  // Initialiser le store i18n AVANT le montage de l'app
  const i18nStore = useI18nStore()
  try {
    await i18nStore.initialize()
  } catch (err) {
    console.error('[main] Erreur critique lors de l_initialisation i18n:', err)
    // On pourrait afficher un message d'erreur à l'utilisateur ici
  }

  // Initialiser Vue i18n
  app.use(i18n)
  app.use(router)

  // Monter l'application seulement après initialisation
  app.mount('#app')
  //console.log('[BdC-Frontend] Application Vue.js initialisée et montée.')

  // Initialiser le monitoring des caches après le montage
  const cacheStore = useCacheStore()
  cacheStore.initializeCacheMonitoring()

  // Charger les préférences utilisateur si authentifié (une seule fois au démarrage)
  const authStore = useAuthStore()
  if (authStore.isAuthenticated) {
    const preferencesStore = useUserPreferencesStore()
    // Charger depuis le cache ou l'API si nécessaire (le store gère le cache)
    preferencesStore.loadPreferences().catch(err => {
      console.warn('[main] Erreur chargement préférences au démarrage:', err)
    })
  }

  // Précharger tous les graffitis au démarrage (une seule fois, le store gère le cache)
  const { useGraffitiStore } = await import('@/stores/graffiti')
  const graffitiStore = useGraffitiStore()
  graffitiStore.loadAllGraffitis().catch(err => {
    console.warn('[main] Erreur préchargement graffitis au démarrage:', err)
  })
}

// Lancer l'initialisation
initializeApp().catch(err => {
  console.error('[main] Erreur fatale lors du lancement de l_application:', err)
})

// Test CI Frontend - 2025-06-29
//console.log('[BdC-Frontend] Application Vue.js initialisée')
